var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-analysis"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("学习分析")]),_c('p',[_vm._v("详细的学习数据分析页面，开发中...")])])])}]

export { render, staticRenderFns }